<template>
  <div>
    <data-list :payload="productObj" v-model="pagination" class="product_table" :headers="headers" :total="total" :pagination="pagination" v-resize="displayHeaders">
      <v-container fluid grid-list-xl slot="filterForm">
        <v-layout row class="pb-0">
          <v-flex lg1 class="text-left">
            <v-btn color="primary" :to="routeURL" :disabled="productObj.isTechRole">{{ $t('message.common.new') }}</v-btn>
          </v-flex>
          <v-flex lg1 class="text-right px-1" :style="$i18n.locale === 'no' ? 'max-width: 10%' : ''">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="info" dark v-bind="attrs" v-on="on">
                  {{ $t('message.common.actions') }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="exportProducts">
                  <v-list-item-title>{{ $t('message.product.exportAllData') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="openImportDialog(false, true)">
                  <v-list-item-title>{{ $t('message.product.importAllData') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="openImportDialog(true, false)">
                  <v-list-item-title>{{ $t('message.product.exportSupplierPrices') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="openImportDialog(true, true)">
                  <v-list-item-title>{{ $t('message.product.importSupplierPrices') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="priceAdjustDialogHandler">
                  <v-list-item-title>{{ $t('message.product.supplierPriceAdjustment') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-flex>
            <!-- <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="info" dark v-bind="attrs" v-on="on">
                  {{ $t('message.common.export') }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="exportProducts">
                  <v-list-item-title>{{ $t('message.whOrder.allData') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="openImportDialog(true, false)">
                  <v-list-item-title>{{ $t('message.whOrder.supplierPrices') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
             <v-btn color="info" :loading="exportLoading" @click="exportProducts" dark>{{ $t('message.common.export') }}</v-btn>
          <v-flex lg1 class="text-right">
            <v-btn color="info" @click="priceAdjustDialogHandler" dark>{{ $t('message.product.priceAdj') }}</v-btn>
          </v-flex>
          <v-flex lg1>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="success" dark v-bind="attrs" v-on="on" :disabled="productObj.isTechRole">
                  {{ $t('message.common.import') }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="openImportDialog(false, true)">
                  <v-list-item-title>{{ $t('message.whOrder.allData') }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="openImportDialog(true, true)">
                  <v-list-item-title>{{ $t('message.whOrder.supplierPrices') }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-flex> -->
          <v-flex lg2 class="px-1">
            <v-autocomplete autocomplete="off" clearable v-model="filterObj.mainsupplier" @change="getProductsHandler" :items="listOfSuppliers" item-text="name" item-value="id" :label="$t('message.customer.mainSupplier')" dense hide-details outlined></v-autocomplete>
          </v-flex>
          <v-flex lg1 class="px-1">
            <v-autocomplete autocomplete="off" clearable v-model="filterObj.subsupplier" @change="getProductsHandler" :items="listOfSuppliers" item-text="name" item-value="id" :label="$t('message.customer.secondarySupplier')" dense hide-details outlined></v-autocomplete>
          </v-flex>
          <v-flex lg1 class="packageInput px-1">
            <v-autocomplete autocomplete="off" v-model="filterObj.whattoshow" @change="getProductsHandler" :items="listOfProductFilters" item-text="name" item-value="id"
             dense hide-details outlined></v-autocomplete>
          </v-flex>
          <v-flex lg1 class="px-1">
            <v-select :items="activeTypes" dense v-model="filterObj.status" @change="getProductsHandler" outlined item-text="text" item-value="id" :label="$t('message.tickets.status')" hide-details></v-select>
          </v-flex>
          <v-flex lg2 class="px-1">
            <v-autocomplete autocomplete="off" clearable v-model="filterObj.groupid" @change="getProductsHandler" :items="listOfProductGroups" item-text="name" item-value="id" :label="$t('message.user.group')" dense hide-details outlined></v-autocomplete>
          </v-flex>
          <v-flex lg2 xs12 sm6 md4 class="text-right px-1">
            <v-text-field outlined dense persistent-hint :hint="$t('message.common.searchTriggerHint')" clearable append-icon="search" @keyup.enter="searchLoading = true;getProductsHandler()" @click:append="searchLoading = true;getProductsHandler()"  single-line v-model="filterObj.search" :loading="searchLoading" :label="$t('message.common.search')" class="search-hint-padding" id="searchbtn"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </data-list>
    <!-- Import Dialog -->
    <v-dialog persistent max-width="600px" v-model="importDialog">
      <v-card>
        <v-card-title>
          <h3>{{ isImport ? $t('message.common.importProducts') : $t('message.common.exportProducts') }}</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-3">
          <v-form ref="importForm" :key="importDialog">
            <v-row>
              <v-col cols="12" lg="12" v-if="showSupplierImport">
                <v-autocomplete autocomplete="off" clearable v-model="importSupplier" :items="listOfSuppliers" item-text="name" item-value="id" :label="$t('message.order.supplier')" dense hide-details outlined></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="12" v-if="isImport">
                <v-file-input :label="$t('message.product.chooseFile')" accept=".xlsx, .xls" outlined v-model="importFile" hide-details></v-file-input>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-flex class="text-end">
            <v-btn color="info" @click="importFileHandler" :loading="loader">{{ isImport ? $t('message.common.import') : $t('message.common.export') }}</v-btn>
            <v-btn class="ml-2" color="error" @click="importDialog = false, $refs.importForm.reset()">{{$t('message.common.close')}}</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Price adjust Dialog -->
    <v-dialog persistent max-width="600px" v-model="priceAdjustDialog">
      <v-card>
        <v-card-title>
          <h4>{{$t('message.product.priceAdjustments')}}</h4>
        </v-card-title>
        <v-divider></v-divider>
        <form-data :references.sync="formReferences" :model="priceAdjustObj" ref="priceAdjustReference"></form-data>
      </v-card>
    </v-dialog>
    <v-dialog persistent max-width="600px" v-model="filesDialog">
      <v-card>
        <v-card-title>
          <h3>{{ $t('message.product.attachments') }}</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-1">
          <v-list flat class="pa-1">
            <v-list-item-group color="primary">
              <v-list-item dense v-for="(item, i) in listOfAttachments" :key="i" @click="downloadFile(item.weburl)">
                <v-list-item-icon>
                  <v-icon :size="28" :color="$formatter.mimeTypeOfDocument(item.mimetype).color">{{ $formatter.mimeTypeOfDocument(item.mimetype).icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <a>{{ item.name }}</a>
                </v-list-item-content>
              </v-list-item>
              <p class="pl-2" v-if="listOfAttachments && listOfAttachments.length <= 0">{{ $t('message.common.noResults') }}</p>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-flex class="text-end">
            <v-btn color="error" @click="filesDialog = false">{{$t('message.common.close')}}</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Print Dialog with different size -->
    <v-dialog persistent max-width="600px" v-model="printDialog">
      <v-card>
        <v-card-title>
          <h3>{{$t('message.product.selectPreferredSize')}}</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-0 pb-0">
          <v-form ref="printProducts">
            <v-row>
              <v-col cols="12" lg="12">
                <v-radio-group v-model="printerSize" :mandatory="false">
                  <v-radio label="57*32" value="2.24409"></v-radio>
                  <v-radio label="106*32" value="4.17323"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-flex class="text-center">
            <v-btn color="info" @click="printProductLabels" :loading="printingLoader">{{$t('message.product.print')}}</v-btn>
            <v-btn color="error" @click="printDialog = false, $refs.printProducts.reset()">{{$t('message.common.close')}}</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--- Export msg dialog while sending through email -->
    <v-dialog persistent max-width="600px" v-model="showExportMsgDialog">
      <v-card>
        <v-card-title>
          <h3>{{$t('message.common.information')}}</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2 pb-2">
          <h4>{{ $t('message.product.exportMsg') }}</h4>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-flex class="text-center">
            <v-btn color="error" @click="showExportMsgDialog = false">{{$t('message.common.close')}}</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import DataList from '@/components/DataList.vue'
import { mapState } from 'vuex'
import FormTemplate from '@/components/FormTemplate'
import axios from 'axios'
export default {
  data () {
    return {
      productObj: {
        isHeader: true,
        isHideAdd: true,
        selection: [],
        showSelect: true,
        addNewRoute: () => this.$router.push(this.routeURL),
        isTechRole: JSON.parse(this.$cookie.get(process.env.VUE_APP_USER)).role_id === 3,
        list: [],
        loading: true,
        page: 1,
        editProp: 'number',
        onedriveProp: 'number',
        editURL: (item) => `${this.routeURL}/${item.id}`,
        hasFilters: true,
        isProductSelect: true,
        export: this.exportSelectedProduct,
        print: this.getSizeOfPrinter,
        actionsList: [{
          click: (item) => this.getListOfFiles(item),
          icon: () => 'mdi-attachment mdi-rotate-315',
          is_show: (item) => true
        }]
      },
      total: 0,
      exportLoading: false,
      filterGroup: '',
      filerByPackage: false,
      routeURL: '/w_h/products/actions',
      pagination: !this.$formatter.isEmptyObject(this.$store.state.PRODUCT_INDEX) ? this.$store.state.PRODUCT_INDEX : { sortBy: ['number'], itemsPerPage: 25, sortDesc: [false], search: '' },
      MODULE_URL: 'products',
      search: '',
      importDialog: false,
      importFile: [],
      loader: false,
      listOfAttachments: [],
      filesDialog: false,
      printDialog: false,
      printingLoader: false,
      printerSize: '2.24409',
      showExportMsgDialog: false,
      syncLoading: false,
      filterObj: {
        search: '',
        status: 1,
        whattoshow: 0
      },
      priceAdjustLoading: false,
      priceAdjustDialog: false,
      priceAdjustObj: {},
      importSupplier: 0,
      showSupplierImport: false,
      isImport: true,
      searchLoading: false
    }
  },
  components: {
    DataList,
    'form-data': FormTemplate
  },
  computed: {
    ...mapState(['FORM_TYPE', 'PRODUCT_INDEX', 'listOfProductGroups', 'listOfSuppliers']),
    headers () {
      const headers = [{
        text: this.$t('message.product.number'),
        value: 'number',
        width: '10%'
      }, {
        text: `${this.$t('message.customer.name')}`,
        value: 'name',
        width: '20%'
      }, {
        text: this.$t('message.products.unit'),
        value: 'productunitname',
        width: '5%'
      }, {
        text: this.$t('message.user.group'),
        value: 'productgroupname',
        width: '8%'
      }, {
        text: this.$t('message.product.type'),
        value: 'type',
        width: '8%'
      }, {
        text: this.$t('message.products.operation_type'),
        value: 'workflowname',
        width: '8%'
      }, {
        text: this.$t('message.product.costPrice'),
        value: 'costprice',
        align: 'end',
        width: '8%'
      }, {
        text: this.$t('message.product.grossMargin'),
        value: 'grosmargin',
        align: 'end',
        width: '8%'
      }, {
        text: this.$t('message.product.salePrice'),
        value: 'salesprice',
        align: 'end',
        width: '8%'
      }, {
        text: this.$t('message.product.priceValidFrom'),
        value: 'pricevalidfrom',
        width: '8%'
      }, {
        text: this.$t('message.product.isPackage'),
        value: 'ispackage',
        isBoolean: true,
        sortable: false,
        width: '4%'
      }, {
        text: this.$t('message.common.isActive'),
        value: 'isactive',
        isBoolean: true,
        sortable: false,
        width: '4%'
      }, {
        text: '',
        value: 'actions',
        width: '4%'
      }]
      return headers
    },
    formReferences () {
      return {
        properties: [{
          model: 'supplierid',
          rules: this.$_requiredValidation,
          type: this.FORM_TYPE.AUTO_COMPLETE,
          class: 'xs12',
          items: this.listOfSuppliers,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.order.supplier')
        }, {
          model: 'productgroups',
          rules: this.$_multiSelectValidation,
          type: this.FORM_TYPE.AUTO_COMPLETE,
          class: 'xs12',
          multiple: true,
          items: this.listOfProductGroups,
          select_text: 'name',
          select_value: 'id',
          label: this.$t('message.customer.productGroup')
        }, {
          model: 'date',
          type: this.FORM_TYPE.DATEPICKER,
          rules: this.$_requiredValidation,
          picker: 'datePicker',
          menu: 'dateMenu',
          label: this.$t('message.product.dateFrom'),
          class: 'xs12',
          color: 'primary lighten-1'
        }, {
          model: 'adjustbyval',
          type: this.FORM_TYPE.TEXT,
          rules: this.priceAdjustObj.adjustbyval ? this.$_discountWithMinusValidation : this.$_requiredValidation,
          label: this.$t('message.product.adjustByIn'),
          class: 'xs12'
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.priceAdjustObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.performPriceAdjustHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closePriceDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    },
    activeTypes () {
      return [
        { text: this.$t('message.tickets.all'), id: 0 },
        { text: this.$t('message.customer.active'), id: 1 },
        { text: this.$t('message.customer.Inactive'), id: 2 }
      ]
    },
    listOfProductFilters () {
      return [{
        name: this.$t('message.tickets.all'),
        id: 0
      }, {
        name: this.$t('message.product.package'),
        id: 1
      }, {
        name: this.$t('message.layout.products'),
        id: 2
      }]
    }
  },
  watch: {
    pagination (val) {
      const model = { type: 'PRODUCT_INDEX', data: val }
      this.$store.commit('rememberOrder', model)
      this.getProductsHandler()
    },
    'filterObj.search' (val) {
      if (!val) {
        this.searchLoading = true
        this.getProductsHandler()
      }
    },
    'priceAdjustObj.datePicker' (val) {
      if (val) {
        this.priceAdjustObj.date = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
      }
    },
    filterGroup (val) {
      this.getProductsHandler()
    }
  },
  mounted () {
    const text = this.$t('message.common.deleteSuccess')
    if (!this.$formatter.isEmptyObject(this.$store.state.F_PRODUCT)) {
      const warehouseFilters = this.$formatter.cloneVariable(this.$store.state.F_PRODUCT)
      const { mainsupplier, subsupplier, whattoshow, groupid } = warehouseFilters.filter
      this.filterObj.mainsupplier = mainsupplier || 0
      this.filterObj.subsupplier = subsupplier || 0
      this.filterObj.whattoshow = whattoshow || 0
      this.filterObj.groupid = groupid || 0
    }
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE_URL) {
        const payload = { ids: data.ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.productObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getProductsHandler()
      }
    })
    this.$store.dispatch('getProductGroups')
    this.$store.dispatch('getSupplierList')
    this.debouncedGetSearchResults = this.$formatter.debounce(this.getProductsHandler, 400)
  },
  methods: {
    openImportDialog (isSupplier, isImport) {
      this.importDialog = true
      this.importFile = []
      this.showSupplierImport = isSupplier
      this.isImport = isImport
    },
    displayHeaders () {
      this.productObj.headers = this.headers
    },
    getProductsHandler () {
      this.productObj.loading = true
      this.productObj.module = this.MODULE_URL
      const { page, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      const pageVal = page || 1
      const model = { ...this.filterObj, sortby: sortBy[0], rowsperpage: itemsPerPage, page: pageVal, descending: sortDesc[0] }
      model.whattoshow = model.whattoshow || 0
      if (!model.mainsupplier) model.mainsupplier = 0
      if (!model.subsupplier) model.subsupplier = 0
      if (!model.groupid) model.groupid = 0
      this.$_executeApi('post', `${this.MODULE_URL}/paginate_filter`, model)
        .then((response) => {
          const { items, total } = response.data
          this.productObj.loading = false
          const transformData = {
            number: { list: ['grosmargin', 'costprice', 'salesprice', 'salespriceincvat'], format: 'replaceDotWithComma' },
            date: { list: ['pricevalidfrom'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' }
          }
          const model = this.$_formatListModel(items, transformData)
          if (model && model.length > 0) {
            model.map(x => {
              if (x.type === 'work') x.type = this.$t('message.product.work')
              else if (x.type === 'product') x.type = this.$t('message.layout.product')
              return x
            })
          }
          this.productObj.list = model
          this.total = total
          if (page > 1 && this.total < itemsPerPage * (page - 1)) {
            this.pagination.page = 1
            this.productObj.page = 1
          }
          const data = { type: 'F_PRODUCT', data: { filter: this.filterObj } }
          this.$store.commit('rememberFilter', data)
        })
        .finally(() => {
          this.searchLoading = false
        })
    },
    getListOfFiles (item) {
      if (item.sharepoint_id) {
        this.productObj.loading = true
        this.$_executeApi('get', `sharepoint/get_children_documents/${item.sharepoint_id}`)
          .then((response) => {
            this.listOfAttachments = []
            this.filesDialog = true
            if (response.data) {
              this.listOfAttachments = response.data
            }
          })
          .finally(() => {
            this.productObj.loading = false
          })
      } else {
        this.listOfAttachments = []
        this.filesDialog = true
      }
    },
    downloadFile (weburl) {
      window.open(weburl, '_blank')
    },
    exportSelectedProduct (listOfIds) {
      this.$_executeApi('post', `${this.MODULE_URL}/export_selected`, listOfIds)
        .then((response) => {
          if (response.data.action === 1) this.$_downloadExportedReport(response.data.filename).then(() => { this.exportLoading = false })
          else {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.product.reportIsReady') })
            this.exportLoading = false
          }
          // if (response.data && response.data.action === 2) this.showExportMsgDialog = true
          // else this.$_downloadExportedReport(response.data.filename)
        })
    },
    exportProducts () {
      this.exportLoading = true
      this.$_executeApi('post', `${this.MODULE_URL}/export?is_package=${this.filterObj.whattoshow ? this.filterObj.whattoshow === 1 : false}&group_id=${this.filterObj.groupid || ''}&main_supplier=${this.filterObj.mainsupplier || 0}`)
        .then((response) => {
          if (response && response.data) {
            if (response.data.action === 1) this.$_downloadExportedReport(response.data.filename).then(() => { this.exportLoading = false })
            else {
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.product.reportIsReady') })
              this.exportLoading = false
            }
          }
        })
        .catch(() => {
          this.exportLoading = false
        })
    },
    importFileHandler () {
      const file = this.importFile
      var formData = new FormData()
      formData.append(file.name, file)
      this.loader = true
      if (this.isImport) {
        const file = this.importFile
        const formData = new FormData()
        formData.append(file.name, file)
        const url = this.showSupplierImport ? `products/import_from_excel?type=3&supplierId=${this.importSupplier || 0}` : 'products/import_from_excel?type=1'
        this.$_executeApi('post', url, formData).then(response => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.importSuccess') })
          this.importFile = []
          this.$refs.importForm.reset()
          this.importDialog = false
          this.getProductsHandler()
        }).finally(() => {
          this.loader = false
        })
      } else {
        const url = `products/export_selected_supplier_prices/${this.importSupplier || 0}`
        this.$_executeApi('post', url).then(response => {
          this.$refs.importForm.reset()
          this.importDialog = false
          const fileName = response.data
          window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
        }).finally(() => {
          this.loader = false
        })
      }
    },
    getSizeOfPrinter (products) {
      this.printDialog = true
      this.printProductsList = products
    },
    printProductLabels () {
      if (this.printProductsList) {
        this.printingLoader = true
        const getIds = this.printProductsList.map(x => x.id)
        const model = { ids: getIds, height: 1.25984, width: (this.printerSize || '2.24409') }
        this.$_executeApi('post', 'products/generate_label_pdf', model)
          .then((response) => {
            window.open(`${process.env.VUE_APP_PRINT_PRODUCT_URL}${response.data}`, '_blank')
          })
          .finally(() => {
            this.printDialog = false
            this.printingLoader = false
          })
      }
    },
    priceAdjustDialogHandler () {
      this.priceAdjustDialog = true
    },
    performPriceAdjustHandler () {
      if (this.$refs.priceAdjustReference.$refs.validateForm.validate()) {
        const model = this.$formatter.cloneVariable(this.priceAdjustObj)
        model.adjustbyval = this.$formatter.replaceCommaWithDot(model.adjustbyval)
        const date = this.$formatter.formatDate(model.date, 'DD.MM.YYYY', 'MM.DD.YYYY')
        model.date = date
        this.priceAdjustLoading = true
        this.$_executeApi('post', 'products/mass_adjust_prices', model)
          .then((response) => {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.updatedSuccess') })
          })
          .finally(() => {
            this.closePriceDialogHandler()
            this.priceAdjustLoading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    closePriceDialogHandler () {
      this.priceAdjustDialog = false
      this.priceAdjustObj.datePicker = null
      this.$refs.priceAdjustReference.$refs.validateForm.reset()
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
<style>
  .packageInput .v-input--selection-controls {
    margin-top: 0px !important;
  }
  .product_table table th, .product_table table td {
    padding: 0 6px !important;
  }
</style>
